export const CheckCircleIcon = (): JSX.Element => (
   <svg width='38' height='38' viewBox='0 0 38 38' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
         d='M19 0C29.4877 0.000176092 38 8.51229 38 19C37.9998 29.4876 29.4876 37.9998 19 38C8.51229 38 0.00017262 29.4877 0 19C2.78976e-06 8.51218 8.51218 2.78958e-06 19 0Z'
         fill='#48A267'
      />
      <path
         fillRule='evenodd'
         clipRule='evenodd'
         d='M16.1429 26L9 18.8023L11.0143 16.7726L16.1429 21.9261L26.9857 11L29 13.0441L16.1429 26Z'
         fill='white'
      />
   </svg>
);
